import { Header } from "./Header.";
import Footer from "./Footer";
import "./Styles/commands.css";
import React, { useEffect, useState } from "react";
import PageHeader from "./PageHeader";
import Cookies from "universal-cookie";
// import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import EmptyCardGIF from "../Images/empty-cart.gif";
import { CommandDetails } from "./CommandDetail";
import moment from "moment/moment";

export const Commands = () => {
  const cookies = new Cookies();

  document.title = "Mes Commandes - KabaaShop";

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_BASE_URL + "/api/orders?user.id="+cookies.get('user').id, {
        headers: {
          "x-api-token": process.env.REACT_APP_API_TOKEN,
        },
      })
      .then((a) => {
        let res = a.data.filter(x => x.status != "cart")

        setListCmd(res);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const [currDetailsCmd, setCurrDetailsCmd] = useState(null);
  const [listCmd, setListCmd] = useState([]);
  const [showCmd, setShowCmd] = useState(<></>);

  function ShowDetailsCmd(content){
    setCurrDetailsCmd(content)
  }

  useEffect(() => {
    if (listCmd.length === 0) {
      setShowCmd(
        <div
          className='no-products-in-cart'
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
            alignItems: "center",
            justifyContent: "center",
            height: "auto",
            boxSizing: "border-box",
            padding: "10px 0",
          }}
        >
          <img src={EmptyCardGIF} alt='no-card-gif' />
          <h3>Aucune commande effectuée</h3>
        </div>
      );
    } else {
      let tabList = [];
      listCmd.forEach((element) => {
        let dateCMD = moment(element.confirmedAt).format("DD/MM/YYYY")
        let returned = (
          <div onClick={()=>ShowDetailsCmd(element)} className='row-command'>
            <div className='left-side-cmd'>
              <span>ID: {element.Code} ({dateCMD})</span>
              <span>{element.orderedProducts.length} produit(s) commandé(s)</span>
            </div>
            <div>
              <span>Status</span>
              {
                element.status == 'confirmed' ?
                <span>Confirmé</span> :
                <span>Annulé</span>
              }
            </div>
          </div>
        );
        tabList.push(returned)
      });

      setShowCmd(tabList)
    }
  }, [listCmd,currDetailsCmd]);

  return (
    <>
      {/* <ToastContainer /> */}
      <Header />
      <PageHeader title={"Mes Commandes"} />
      <div className="content-command">
        {showCmd}
      </div>
      <CommandDetails currentDetail={currDetailsCmd} setCurrentDetail={setCurrDetailsCmd} />
      <Footer />
    </>
  );
};
